"use strict";
var decorators_1 = require("./pipes/decorators");
exports.Pipe = decorators_1.Pipe;
//# sourceMappingURL=pipes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-metadata/src/core/pipes.js
// module id = 515
// module chunks = 6